module.exports = __webpack_public_path__ + "static/img/1.4499887.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/eng/1.png
// module id = 7/gG
// module chunks = 0